/**
 * Account store — Clerk edition.
 *
 * Clerk owns all auth tokens and session management. This store holds only the
 * app-level state that Clerk doesn't know about:
 *   • Local user profile (username, name, etc. from our own DB)
 *   • Whether post-signup onboarding is complete
 *   • The list of cellars the user belongs to and which one is active
 *
 * Token storage and refresh are gone — Clerk handles those.
 */
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
export const useAccountStore = create()(persist((set) => ({
    user: null,
    profileComplete: false,
    activeAccount: null,
    accounts: [],
    setUser: (user) => set({ user }),
    setProfileComplete: (profileComplete) => set({ profileComplete }),
    setActiveAccount: (account) => set({ activeAccount: account }),
    setAccounts: (accounts) => set({ accounts }),
    updateUser: (patch) => set((s) => ({ user: s.user ? { ...s.user, ...patch } : s.user })),
    clearAuth: () => set({
        user: null,
        profileComplete: false,
        activeAccount: null,
        accounts: [],
    }),
}), {
    name: 'cellar-manager-auth',
    partialize: (state) => ({
        user: state.user,
        profileComplete: state.profileComplete,
        activeAccount: state.activeAccount,
        accounts: state.accounts,
    }),
}));
